import Navigation from './navigation';

var MobileNavPlugin = Navigation.Plugin.extend({
  onModelLoaded: function (model) {
    var nav = this.getNavigation();

    // Build out the mobile region based on the primary, utility and expanded regions
    var mobileCTAs = nav.getRegionByKey('mobile-cta');
    var mobileExpanded = nav.getRegionByKey('mobile-expanded');

    var customMobileEnabled = false;
    if (model.features) {
      customMobileEnabled = !!model.features.customMobile;
    }

    if (!customMobileEnabled || (!mobileCTAs && !mobileExpanded)) {
      nav.removeRegionByKey('mobile-cta');
      nav.removeRegionByKey('mobile-expanded');

      var utilityRegion = nav.getRegionByKey('utility');
      var primaryRegion = nav.getRegionByKey('primary');
      var expandedRegion = nav.getRegionByKey('expanded');

      // We don't already have the mobile regions, generate them
      mobileCTAs = nav.createRegion('mobile-cta', 'Mobile CTAs');
      mobileCTAs.links = primaryRegion.links.slice(0, 3);
      model.links.push(mobileCTAs);

      // Mobile expanded
      mobileExpanded = nav.createRegion('mobile-expanded', 'Mobile Expanded');
      mobileExpanded.links = primaryRegion.links.slice(3).concat(expandedRegion.links).concat(utilityRegion.links);
      model.links.push(mobileExpanded);
    }
  }
});

Navigation.registerPlugin(MobileNavPlugin);
